import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useUIStore } from '../store/ui-store';

interface Props {
  title?: string
  description?: string
}

export const Seo: React.FC<Props> = ({ title, description }: Props) => {
  const { setTitle } = useUIStore();

  useEffect(() => {
    if (title) {
      setTitle(title);
    }
    return () => {
      setTitle('');
    };
  }, [title, setTitle]);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
    </Helmet>
  );
};

Seo.defaultProps = {
  title: 'Boston Heart Diagnostics',
  description: 'A website for BHD',
};
